"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_1 = require("mobx");
var Window_1 = require("./Window");
var ComponentTypes = require("./ComponentTypes");
var WindowManager_1 = require("./WindowManager");
var SplitActions_1 = require("../SplitActions");
/**
 * Stack - a bunch/stack of windows
 */
var Stack = /** @class */ (function (_super) {
    __extends(Stack, _super);
    function Stack() {
        var _this = _super.call(this) || this;
        _this._headerHeight = 28;
        _this._setWindowViewports = function () {
            if (_this.portalManager) {
                var childY_1 = _this.y + _this.headerHeight;
                var childHeight_1 = _this.height - _this.headerHeight;
                var active_1 = _this.active;
                _this.windows.forEach(function (w) {
                    w.setViewport(_this.x, childY_1, w === active_1 ? _this.width : 0, w === active_1 ? childHeight_1 : 0);
                });
            }
        };
        _this._setViewportDisposer = mobx_1.autorun(_this._setWindowViewports);
        return _this;
    }
    Object.defineProperty(Stack.prototype, "type", {
        get: function () {
            return ComponentTypes.stack;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Stack.prototype, "headerHeight", {
        get: function () {
            return this._headerHeight;
        },
        set: function (value) {
            this.setHeaderHeight(value);
        },
        enumerable: true,
        configurable: true
    });
    Stack.prototype.setHeaderHeight = function (headerHeight) {
        if (headerHeight >= 0 && headerHeight !== this._headerHeight) {
            this._headerHeight = headerHeight;
        }
    };
    Object.defineProperty(Stack.prototype, "activeIndex", {
        get: function () {
            return this._activeIndex || 0;
        },
        set: function (value) {
            this.setActiveIndex(value);
        },
        enumerable: true,
        configurable: true
    });
    Stack.prototype.setActiveIndex = function (activeIndex) {
        if (activeIndex !== this._activeIndex) {
            this._activeIndex = activeIndex;
        }
    };
    Object.defineProperty(Stack.prototype, "active", {
        get: function () {
            return this.activeIndex >= 0 && this.activeIndex < this.windows.length ? this.windows[this.activeIndex] : undefined;
        },
        set: function (value) {
            this.setActive(value);
        },
        enumerable: true,
        configurable: true
    });
    Stack.prototype.setActive = function (active) {
        this.setActiveIndex(this.windows.indexOf(active));
    };
    Stack.prototype.add = function (win, opts) {
        _super.prototype.add.call(this, win, opts);
        if ((opts && opts.makeActive) || this.windows.length === 1) {
            this.setActive(win);
        }
    };
    Stack.prototype._windowDropped = function (win) {
        this.setActive(win);
    };
    Stack.prototype.splitLeft = function (newComp) {
        var newStack = new Stack();
        newStack.setCloseDisabled(this.closeDisabled);
        if (newComp) {
            newStack.add(newComp);
        }
        else {
            newStack.addNew();
        }
        SplitActions_1.splitHorizontal(this, newStack, this);
    };
    Stack.prototype.splitRight = function (newComp) {
        var newStack = new Stack();
        newStack.setCloseDisabled(this.closeDisabled);
        if (newComp) {
            newStack.add(newComp);
        }
        else {
            newStack.addNew();
        }
        SplitActions_1.splitHorizontal(this, this, newStack);
    };
    Stack.prototype.splitTop = function (newComp) {
        var newStack = new Stack();
        newStack.setCloseDisabled(this.closeDisabled);
        if (newComp) {
            newStack.add(newComp);
        }
        else {
            newStack.addNew();
        }
        SplitActions_1.splitVertical(this, newStack, this);
    };
    Stack.prototype.splitBottom = function (newComp) {
        var newStack = new Stack();
        newStack.setCloseDisabled(this.closeDisabled);
        if (newComp) {
            newStack.add(newComp);
        }
        else {
            newStack.addNew();
        }
        SplitActions_1.splitVertical(this, this, newStack);
    };
    Object.defineProperty(Stack.prototype, "config", {
        get: function () {
            return {
                type: this.type,
                activeIndex: this.activeIndex,
                windows: this.windows.filter(function (w) { return !w.transient; }).map(function (w) { return w.config; }),
                closeDisabled: this.closeDisabled
            };
        },
        set: function (value) {
            this.setConfig(value);
        },
        enumerable: true,
        configurable: true
    });
    Stack.prototype.setConfig = function (config) {
        var _this = this;
        this.windows = [];
        var windowPromise;
        if (config && config.windows && config.windows.length > 0) {
            config.windows.forEach(function (wc) {
                var w = new Window_1.Window();
                _this.add(w);
                w.setConfig(wc);
            });
        }
        this.setActiveIndex(config && !isNaN(config.activeIndex) ? config.activeIndex : 0);
        this.setCloseDisabled(config ? config.closeDisabled : undefined);
    };
    Stack.prototype.remove = function (node) {
        _super.prototype.remove.call(this, node);
        if (this.windows.length > 0) {
            if (this.activeIndex >= this.windows.length) {
                this.setActiveIndex(this.windows.length - 1);
            }
        }
    };
    __decorate([
        mobx_1.observable
    ], Stack.prototype, "_activeIndex", void 0);
    __decorate([
        mobx_1.observable
    ], Stack.prototype, "_headerHeight", void 0);
    __decorate([
        mobx_1.computed
    ], Stack.prototype, "headerHeight", null);
    __decorate([
        mobx_1.action
    ], Stack.prototype, "setHeaderHeight", null);
    __decorate([
        mobx_1.computed
    ], Stack.prototype, "activeIndex", null);
    __decorate([
        mobx_1.action
    ], Stack.prototype, "setActiveIndex", null);
    __decorate([
        mobx_1.computed
    ], Stack.prototype, "active", null);
    __decorate([
        mobx_1.action
    ], Stack.prototype, "setActive", null);
    __decorate([
        mobx_1.action
    ], Stack.prototype, "add", null);
    __decorate([
        mobx_1.action
    ], Stack.prototype, "splitLeft", null);
    __decorate([
        mobx_1.action
    ], Stack.prototype, "splitRight", null);
    __decorate([
        mobx_1.action
    ], Stack.prototype, "splitTop", null);
    __decorate([
        mobx_1.action
    ], Stack.prototype, "splitBottom", null);
    __decorate([
        mobx_1.computed
    ], Stack.prototype, "config", null);
    __decorate([
        mobx_1.action
    ], Stack.prototype, "setConfig", null);
    __decorate([
        mobx_1.action
    ], Stack.prototype, "remove", null);
    return Stack;
}(WindowManager_1.WindowManager));
exports.Stack = Stack;
